// import { appAddress } from '../../App.js'
import ACTIONS from './index.js'
import axios from 'axios'

export const fetchAllUsers = async (token) => {
    const res = await axios.get(`https://api.niadoffice.com/user/getUsersInfor`, {
    // const res = await axios.get('/user/getUsersInfor', {
        headers: {Authorization: token}
    })
    return res
}

export const dispatchGetAllUsers = (res) => {
    return {
        type: ACTIONS.GET_ALL_USERS,
        payload: res.data
    }
}